import { DialogActions, TextField, Typography } from '@mui/material';
import {
  freezeCreditLine,
  getCreditLineAssignations,
  unFreezeCreditLine,
} from 'lib/api';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { hasAnyPermissions } from 'lib/functions/utils';
import { showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

import CreditLineStatus from '../../../../../../../../../common/creditLineStatus';
import ShoppingCartFactoringReviewed from '../2_ShoppingCartReviewed';
import CreditLineConcentrations from '../3_ShoppingCartAssigned/components/Concentrations';

const ShoppingCartFactoringAlive = (props: any) => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const {
    setOpenShoppingCart,
    openShoppingCart,
    openRequest,
    setLoading,
    setUp,
    handleDetails,
  } = props;
  const [inFreezing, setInFreezing] = React.useState(false);
  const [inUnFreezing, setInUnFreezing] = React.useState(false);
  const [editing, setEditing] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [stakeholdersConcentrations, setStakeholdersConcentrations] = useState(
    [],
  );
  const [subProductsConcentrations, setSubProductsConcentrations] = useState(
    [],
  );
  const [miniLoading, setMiniLoading] = useState(false);

  const dispatch = useDispatch();

  const validateMessage = () => {
    return message.length > 0;
  };

  const setUpConcentrations = async () => {
    setMiniLoading(true);
    try {
      const response = await getCreditLineAssignations(dispatch, {
        id: openRequest.id,
      });
      setStakeholdersConcentrations(response.stakeholderAssignations);
      setSubProductsConcentrations(response.subProductAssignations);
    } catch (error) {
      console.error(error);
    }
    setMiniLoading(false);
  };

  const freeze = async () => {
    if (!validateMessage()) {
      return alert('Por favor, ingresa un mensaje');
    }
    setLoading(true);
    try {
      await freezeCreditLine(dispatch, {
        id: openRequest.id,
        message,
      });
      showAlert(dispatch, 'success', 'Hemos congelado la línea de crédito');
      await setUp();
      setOpenShoppingCart(false);
    } catch (error) {
      console.error(error);
    }
  };

  const unFreeze = async () => {
    if (!validateMessage()) {
      return alert('Por favor, ingresa un mensaje');
    }
    setLoading(true);
    try {
      await unFreezeCreditLine(dispatch, {
        id: openRequest.id,
        message,
      });
      showAlert(dispatch, 'success', 'Hemos descongelado la línea de crédito');
      await setUp();
      setOpenShoppingCart(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    void setUpConcentrations();
  }, []);

  if (editing) {
    return (
      <ShoppingCartFactoringReviewed
        openShoppingCart={openShoppingCart}
        setOpenShoppingCart={setOpenShoppingCart}
        openRequest={openRequest}
        inAssignationDefault
        setUp={setUp}
        handleDetails={handleDetails}
        setLoading={setLoading}
        setEditing={setEditing}
      />
    );
  }

  return (
    <div>
      <div>
        <div>
          <CreditLineStatus openRequest={openRequest} audienceType="received" />
          {miniLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CenteredCircularProgress />
            </div>
          ) : (
            <div>
              <div style={{ padding: '20px 0px 0px' }}>
                <CreditLineConcentrations
                  stakeholdersConcentrations={stakeholdersConcentrations}
                  subProductsConcentrations={subProductsConcentrations}
                  productType={openRequest.productType}
                />
              </div>
            </div>
          )}

          {inFreezing || inUnFreezing ? (
            <div>
              <Typography variant="h6" fontWeight={600}>
                {inFreezing ? 'Congelar' : 'Descongelar'} Línea de crédito
              </Typography>
              <Typography variant="body1">
                Por favor, ingresa la razón para{' '}
                <b style={{ color: inFreezing ? 'red' : 'green' }}>
                  {inFreezing ? 'congelar' : 'descongelar'}
                </b>{' '}
                esta línea de crédito
              </Typography>
              <TextField
                label="Razón"
                variant="outlined"
                fullWidth
                multiline
                value={message}
                onChange={(e: any) => setMessage(e.target.value)}
                style={{ marginTop: 10 }}
              />
              <DialogActions>
                <CustomButton
                  onClick={() => {
                    setInFreezing(false);
                    setInUnFreezing(false);
                  }}
                  color="secondary"
                >
                  Cancelar
                </CustomButton>
                <CustomButton
                  onClick={inFreezing ? freeze : unFreeze}
                  color="primary"
                >
                  Confirmar
                </CustomButton>
              </DialogActions>
            </div>
          ) : (
            <div>
              <DialogActions>
                <CustomButton
                  onClick={() => setOpenShoppingCart(false)}
                  color="secondary"
                >
                  Salir
                </CustomButton>
                <CustomButton
                  onClick={() => setEditing(true)}
                  color="primary"
                  disabled={
                    !hasAnyPermissions(user, ['financing_creditLine_edit'])
                  }
                >
                  Editar
                </CustomButton>
                {openRequest.status === 'Activa' ||
                openRequest.status === 'Vencida' ? (
                  <CustomButton
                    onClick={() => setInFreezing(true)}
                    color="error"
                    disabled={
                      !hasAnyPermissions(user, ['financing_creditLine_edit'])
                    }
                  >
                    Congelar
                  </CustomButton>
                ) : (
                  <CustomButton
                    onClick={() => setInUnFreezing(true)}
                    color="success"
                    disabled={
                      !hasAnyPermissions(user, ['financing_creditLine_edit'])
                    }
                  >
                    Descongelar
                  </CustomButton>
                )}
              </DialogActions>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ShoppingCartFactoringAlive;
